import { useEffect, useState } from "react";

/**
 * Tailwind handles layout at breakpoints on its own; this exists for the cases
 * where a number has to cross into JavaScript. Recharts sizes its canvas from a
 * numeric `height` prop and thins its axis ticks from a numeric `interval`, and
 * neither can be expressed as a class.
 *
 * Reads once on mount rather than during render, so server-rendered markup and
 * the first client paint agree.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}

/** True below Tailwind's `sm`, i.e. phone widths. */
export function useIsPhone() {
  return useMediaQuery("(max-width: 639px)");
}
